const normalize = value => String(value ?? '').trim().toUpperCase()

export const findContactCity = (cityId, cities = []) => {
  return cities.find(city => String(city.id) === String(cityId)) || null
}

export const getContactCapSettings = (cityId, cities = []) => {
  const city = findContactCity(cityId, cities)
  const cap = normalize(city?.cap)
  const isWildcard = /^\d{3}XX$/.test(cap)
  const isFixed = /^\d{5}$/.test(cap)

  return {
    city,
    cap,
    isWildcard,
    isFixed,
    mask: isWildcard ? `${cap.slice(0, 3)}99` : '99999',
    prefill: isWildcard ? cap.slice(0, 3) : (isFixed ? cap : '')
  }
}

export const isContactCapValid = (cap, cityId, cities = []) => {
  const value = normalize(cap)
  const settings = getContactCapSettings(cityId, cities)
  if (!/^\d{5}$/.test(value) || !settings.city) return false
  if (settings.isWildcard) return value.startsWith(settings.cap.slice(0, 3))
  return settings.isFixed && value === settings.cap
}

export const getContactAddressInvalidFields = (contact = {}, streetTypes = [], cities = []) => {
  const invalidFields = []
  const streetType = normalize(contact.toponimo)
  const cityId = contact.cod_comune ?? contact.comune

  if (!streetType || !streetTypes.some(item => normalize(item.name) === streetType)) invalidFields.push('toponimo')
  if (!normalize(contact.indirizzo)) invalidFields.push('indirizzo')
  if (!normalize(contact.civico)) invalidFields.push('civico')
  if (!isContactCapValid(contact.cap, cityId, cities)) invalidFields.push('cap')

  return invalidFields
}

export const withContactAddressValidation = (contact = {}, streetTypes = [], cities = []) => {
  const invalidFields = new Set(contact.invalid_fields || [])
  getContactAddressInvalidFields(contact, streetTypes, cities).forEach(field => invalidFields.add(field))
  return {...contact, invalid_fields: [...invalidFields], selectable: invalidFields.size === 0}
}
